export default __webpack_public_path__ + "static/TikTok-59a6d1f4b88be0255e5fc281b5cf5d4d.png";